"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const snakeCase_1 = __importDefault(require("lodash/snakeCase"));
const capitalize_1 = __importDefault(require("lodash/capitalize"));
function sentenceCase(string) {
    return (0, capitalize_1.default)((0, snakeCase_1.default)(string).replace(/_/, ' '));
}
exports.default = sentenceCase;
